/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-05-15 16:59:09
 * @LastEditors: changfeng
 * @LastEditTime: 2024-05-15 17:00:41
 */
export default {
	"common.no data": "No data"
};
